import { render } from "./Type.vue?vue&type=template&id=1908dc39&scoped=true"
import script from "./Type.vue?vue&type=script&lang=js"
export * from "./Type.vue?vue&type=script&lang=js"

import "./Type.vue?vue&type=style&index=0&id=1908dc39&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1908dc39"]])

export default __exports__